export default function ProfilingInput({ value, onChange, onSubmit, loading }) {
  return (
    <div className="reviewInput">
      <p className="inputTitle">신규 환자 초기 문진 데이터:</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        <textarea
          name="textarea"
          rows="10"
          placeholder="예: 30대 여성, 직장인. 잦은 야근과 스트레스로 1년새 8kg 증가. 특히 저녁 식사 후 야식(떡볶이, 라면)을 참기 힘듦. 아침은 거르고 점심은 급하게 먹는 편. 잠들기 어렵고 아침에 개운하지 않음. 최종 목표는 임신 준비를 위한 건강한 체중 감량."
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={loading}
        />
        <button type="submit" className="submitbtn" disabled={loading}>
          {loading ? "생성 중…" : "첫 방문 환자 프로파일링 생성"}
        </button>
      </form>
    </div>
  );
}
